import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const UICard = ({
  title,
  subtitle,
  actions,
  children,
  contentSx,
  cardSx,
  disableContentPadding = false,
  ...props
}) => {
  return (
    <Card sx={cardSx} {...props}>
      <CardContent
        sx={{
          p: disableContentPadding ? 0 : 3,
          "&:last-child": {
            pb: disableContentPadding ? 0 : 3,
          },
          ...contentSx,
        }}
      >
        {(title || subtitle || actions) && (
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            spacing={2}
            sx={{ mb: children ? 2 : 0 }}
          >
            <Stack spacing={0.5}>
              {title ? (
                <Typography variant="h6" color="text.primary">
                  {title}
                </Typography>
              ) : null}
              {subtitle ? (
                <Typography variant="body2" color="text.secondary">
                  {subtitle}
                </Typography>
              ) : null}
            </Stack>
            {actions ? <Stack direction="row" spacing={1}>{actions}</Stack> : null}
          </Stack>
        )}
        {children}
      </CardContent>
    </Card>
  );
};

export default UICard;
